var _g, _g2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVorwaerts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.6 25.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_20",
    "data-name": "Gruppe 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    d: "M799.4,449.4l-12.07-12.07-1.76,1.77,12.06,12.07Z",
    transform: "translate(-756.4 -437.33)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_21",
    "data-name": "Gruppe 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9",
    "data-name": "Pfad 9",
    d: "M787.33,462.67,800,450l-1.77-1.77L785.57,460.9Z",
    transform: "translate(-756.4 -437.33)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10",
    "data-name": "Pfad 10",
    d: "M756.4,448.75h42v2.5h-42Z",
    transform: "translate(-756.4 -437.33)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVorwaerts);
export default __webpack_public_path__ + "static/media/Vorwaerts.6d1b8775.svg";
export { ForwardRef as ReactComponent };